import { createClient } from '@/shared/api';
import MIGRATE_AI_DATA_VER1_TO_VER2_MUTATION from '@/entities/report/api/mutations/migrateAiDataVer1ToVer2';
import type {
  MigrateAiDataVer1ToVer2Mutation,
  MigrateAiDataVer1ToVer2MutationVariables,
} from '@/shared/api/generated/graphql';

export type MigrateAiDataResult = {
  isSuccess: boolean;
  message: string;
};

// TODO(ts): payload shape is defined by the AI service, not in this repo.
export type MigrateAiData = any;

// TODO(ts): typed as the MigrateAiDataInput GraphQL input once its server-side shape is documented
/**
 * Triggers migration of a study's AI data from version 1 to version 2. Runs the migration mutation and throws the server message unless isSuccess is set.
 *
 * @param input - Mutation input identifying the data to migrate.
 * @returns A promise resolving to the migration result.
 */
const fetchMigrateAiData = async (input: MigrateAiData) => {
  const client = await createClient();
  const migrateAiDataVer1ToVer2Result = await client.mutate<
    MigrateAiDataVer1ToVer2Mutation,
    MigrateAiDataVer1ToVer2MutationVariables
  >({
    mutation: MIGRATE_AI_DATA_VER1_TO_VER2_MUTATION,
    variables: {
      input,
    },
  });
  const { data } = migrateAiDataVer1ToVer2Result;
  const { migrateAiDataVer1ToVer2 } = data;
  if (!migrateAiDataVer1ToVer2.isSuccess) {
    throw new Error(migrateAiDataVer1ToVer2.message);
  } else {
    return migrateAiDataVer1ToVer2;
  }
};

export default fetchMigrateAiData;
